export default {
  data() {
    return {
      language: null,
    };
  },

  created() {
    let langCodes = Object.keys(SUPPORT_LOCALES);
    let segments = document.location.pathname.split("/");

    if (segments[1] !== "" && langCodes.includes(segments[1])) {
      this.language = segments[1];
    }
  },

  computed: {
    lang() {
      return !!this.language;
    },
  },
};
